import { CommonModule } from '@angular/common';  
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { LayoutComponent } from './components/layout/layout.component';

import { environment } from '../environments/environment';

import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AngularFireAnalyticsModule } from '@angular/fire/compat/analytics';

import { NetworkInterceptor } from './interceptor/network.interceptor';


@NgModule({
  declarations: [
    AppComponent,    
    HeaderComponent, FooterComponent, LayoutComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,        
    AngularFireAuthModule,    
    AngularFireModule.initializeApp(environment.firebaseConfig),
    HttpClientModule,
    FontAwesomeModule,    
    AngularFireAnalyticsModule,    
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: NetworkInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
